/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DevicesCreateAliases {
  AUTOCOMPLETE_ACTION = 'autocomplete-action',
  AUTOCOMPLETE_ADDITIONAL_BEHAVIOR = 'autocomplete-additional-behavior',
  AUTOCOMPLETE_CALIBER = 'autocomplete-caliber',
  AUTOCOMPLETE_DEVICES = 'autocomplete-devices',
  AUTOCOMPLETE_INSTALATION_SUCCESS = 'autocomplete-instalation-success',
  AUTOCOMPLETE_SIDE = 'autocomplete-side',
  AUTOCOMPLETE_TOPOGRAPHY = 'autocomplete-topography',
  CHECKBOX_BRONCHOASPIRATION = 'checkbox-bronchoaspiration',
  CHECKBOX_ENTERAL_NOSE_PROBE = 'checkbox-enteral-nose-probe',
  CHECKBOX_UNCONSCIOUS = 'checkbox-unconscious',
  DEVICES_CREATE_LAYOUT = 'devices-create-layout',
  DYNAMIC_FIELDS = 'dynamic-fields',
  FETCH_ACTION = 'fetch-action',
  FETCH_CALIBER = 'fetch-caliber',
  FETCH_COMPLEMENT = 'fetch-complement',
  FETCH_DEVICES = 'fetch-devices',
  FETCH_PROFESSIONAL = 'fetch-professional',
  FETCH_SIDE = 'fetch-side',
  FETCH_TOPOGRAPHY = 'fetch-topography',
  FIELD_ACTION = 'field-action',
  FIELD_ADITIONAL_BEHAVIOR = 'field-aditional-behavior',
  FIELD_ATTEMPTS = 'field-attempts',
  FIELD_BRONCHOASPIRATION = 'field-bronchoaspiration',
  FIELD_CALIBER = 'field-caliber',
  FIELD_DEVICE_USED = 'field-device-used',
  FIELD_DEVICES = 'field-devices',
  FIELD_DRESSING_SCHEDULE_REMOVAL = 'field-dressing-schedule-removal',
  FIELD_ENTERAL_NOSE_PROBE = 'field-enteral-nose-probe',
  FIELD_INSTALATION_SUCCESS = 'field-instalation-success',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PERMANENCE = 'field-permanence',
  FIELD_PLANNED_PERMANENCE = 'field-planned-permanence',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_SCHEDULE_REMOVAL = 'field-schedule-removal',
  FIELD_SETUP_DATE = 'field-setup-date',
  FIELD_SIDE = 'field-side',
  FIELD_TOPOGRAPHY = 'field-topography',
  FIELD_UNCONSCIOUS = 'field-unconscious',
  FIELDSET_DYNAMIC_FIELDS = 'fieldset-dynamic-fields',
  FORM_CONTEXTUAL_BAR = 'form-contextual-bar',
  FORM_DEVICES = 'form-devices',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_ATTEMPTS = 'input-attempts',
  INPUT_DEVICE_USED = 'input-device-used',
  INPUT_DRESSING_SCHEDULE_REMOVAL = 'input-dressing-schedule-removal',
  INPUT_PERMANENCE = 'input-permanence',
  INPUT_PLANNED_PERMANENCE = 'input-planned-permanence',
  INPUT_PROFESSIONAL = 'input-professional',
  INPUT_SCHEDULE_RENOVAL = 'input-schedule-renoval',
  INPUT_SETUP_DATE = 'input-setup-date',
  LOCATOR_FIELD_PROFESSIONAL = 'locator-field-professional',
  LOCATOR_PROFESSIONAL = 'locator-professional',
  MAPPER_ACTION = 'mapper-action',
  MAPPER_CALIBER = 'mapper-caliber',
  MAPPER_COMPLEMENT = 'mapper-complement',
  MAPPER_DEVICES = 'mapper-devices',
  MAPPER_INSTALATION = 'mapper-instalation',
  MAPPER_SITE = 'mapper-site',
  MAPPER_TOPOGRAPHY = 'mapper-topography',
  PANEL_BODY = 'panel-body',
  PANEL_FORM = 'panel-form',
  PANEL_HEADER = 'panel-header',
  TEXT_ACTION = 'text-action',
  TEXT_AREA_OBSERVATION = 'text-area-observation',
  TEXT_CALIBER = 'text-caliber',
  TEXT_COMPLEMENT = 'text-complement',
  TEXT_DEVICES = 'text-devices',
  TEXT_INSTALATION = 'text-instalation',
  TEXT_SITE = 'text-site',
  TEXT_TOPOGRAPHY = 'text-topography',
}
export { DevicesCreateAliases };
